export const getSnackbars = state => state.snackbar.snackbars;
